// @module C3.ShoppingExtensions.System8Page
define('C3.PDPSerialLotFunctionality.SerialLotData.PDHighlightsView'
,	[
	    'pdhighlights.tpl'
	,	'SCView'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'

    ]
, function (
	    pdhighlights_tpl
	,	SCViewModule
	,   GlobalViewsBreadcrumbView
	,   Utils
)
{
    'use strict';

     var SCView = SCViewModule.SCView;

     function PDHighlightsView (options) {
     	SCView.call(this, options);

     	  this.template = pdhighlights_tpl;
        this.options = options;
        this.model = options.model;
     }

     PDHighlightsView.prototype = Object.create(SCView.prototype);
     PDHighlightsView.prototype.constructor = PDHighlightsView;


     PDHighlightsView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    PDHighlightsView.prototype.getContext = function () {
    	//console.log(this.options)
    	return {
    		name : this.model.get('name'),
    		value : this.model.get('value')
    	}
    }

     return PDHighlightsView;
});
